// extracted by mini-css-extract-plugin
export default {"dropdownManage":"Dropdown_dropdownManage__q+rJJ"};